import React from "react";
import { Typography, Paper, Box } from "@mui/material";

const TermsOfServices = ({ height }) => {
  return (
    <>
      {/* <Paper elevation={3} sx={{ p: 4, mt: 4, borderRadius: 2 }}> */}
      <Paper
        elevation={3}
        sx={{
          padding: height ? "2rem" : "0",
          backgroundColor: "#fff",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          maxHeight: height ? height : "100vh",
          overflow: "auto",
        }}
      >
        <Box
          style={{
            border: "1px solid black",
            margin: "1.5rem",
            padding: "2rem",
            borderRadius: "8px",
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "20px",
              textAlign: "center",
              marginBottom: "1rem",
              fontFamily: "Inter",
            }}
          >
            NIRANTARA TERMS OF USE
          </Typography>
          <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }} paragraph>
            Welcome to Vajra!
          </Typography>

          <Typography
            sx={{ fontWeight: 600, fontSize: "16px", fontFamily: "Inter" }}
            gutterBottom
          >
            1. Introduction
          </Typography>

          <Box sx={{ marginLeft: "1rem" }}>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (a)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Nirantara Ecoventures Private Limited is a private limited
                company incorporated under the Companies Act, 2013 having its
                registered office New No.16 Old No.18, Chengalvarayan Street,
                Shenoy Nagar, Chennai, Egmore Nungambakkam, Tamil Nadu, India,
                600030 (hereinafter referred to as
                <b> “Company”/“Nirantara”/“We”/“Our”/“Us”</b> ) The Company
                owns, operates and manages the website
                https://nirantara.ai/(hereinafter referred to as{" "}
                <b>“Website”</b>) including an optimized version of the Website
                designed for access via mobile phones, smart devices and other
                compatible devices (hereinafter referred to as “WebApp Version”)
                under the brand name <b>“Vajra”</b> (the Website and the WebApp
                Version shall be collectively referred to as the{" "}
                <b>“Platform”</b>).
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (b)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                By accessing or using the Platform, the user (hereinafter
                referred to as <b>“User/s”, “You” or “Your”</b>) acknowledges
                that the User has read, understood, and agrees to comply with
                these Terms of Service. If You have any concerns or do not agree
                with any part of these Terms, We encourage You to reach out to
                Us for clarification before proceeding with the use of the
                Platform.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (c)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Vajra is a specialized platform focused on enabling responsible
                and sustainable business transformation by integrating
                Environmental, Social, and Governance (<b>“ESG”</b>)
                considerations into strategic decision-making. Through a
                combination of deep subject-matter expertise, curated tools, and
                collaborative insights, Nirantara empowers organizations to
                navigate the evolving ESG landscape with clarity and purpose.
                The Platform provides Users with access to curated ESG
                resources, sector-specific insights, implementation support, and
                customised engagement models to assess, align, and act on
                sustainability goals. Your use of the Platform and related
                Services shall be governed by the Terms set out herein.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (d)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The Company provides the User access to this Platform, including
                all information, tools and services available through this
                Platform, the access to browse through the Services on the
                Platform, and/or access Services using login credentials
                provided by the Company, conditioned upon Your acceptance of all
                terms, conditions, policies and notices stated herein. Your use
                of the Platform and related services available on the Platform,
                including but not limited to viewing information, acting on such
                information and engaging in any transactions facilitated by the
                Platform, is governed by and shall be subject to these terms and
                conditions (hereinafter referred as <b>“Terms of Service”</b> or
                <b>“Terms”</b>), the terms whereof are subject to change or
                amendments at any time, without prior notice to You. Any new
                features or tools which may be added to the Platform by the
                Company shall also be part of the Terms of Service. It is Your
                responsibility to periodically review these Terms of Service and
                all the documents referred to hereunder to stay informed of any
                updates or changes.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (e)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                If You continue to browse through this Platform, You are
                agreeing to be bound by the Terms which along with the Privacy
                Policy, as displayed on the Platform, govern Your relationship
                with us. Further, You confirm that You have also read and
                agreed/accepted to be bound by all additional guidelines, rules,
                conditions and disclaimers, if any, displayed on the Platform,
                which shall deem to be a part of these Terms of Service.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (f)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                In the event You are accessing or using the Platform by
                representing an incorporated legal entity, You hereby represent
                and warrant that You have been expressly and duly authorized by
                such entity to accept the Terms of Service, and such entity
                agrees to be bound by the Terms hereunder.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (g)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The Terms of Service shall be a legally binding agreement
                between You and the Company. Therefore, kindly read the Terms of
                Service carefully before accessing or using the Platform and/or
                the Services.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (h)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                These Terms of Service apply to all Users of the Platform,
                including without limitation Users who are browsers, vendors,
                service providers, collaborators, and/ or contributors of data,
                content, information, pictorial representations and/or images,
                and/or media in any form.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (i)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The Platform and Services can be accessed and used by those
                individuals or business entities, including sole proprietorship
                firms, companies and partnerships, that are legally capable of
                entering into binding contracts under applicable law. Only
                individuals who are eighteen (18) years of age or older may use
                the Platform and avail Services. The Company reserves the right
                to suspend or terminate the User Account and / or deny access to
                the Platform if it is brought to the Company’s notice or if is
                discovered that the User does not meet the conditions herein.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (j)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                These Terms constitute an electronic record in accordance with
                the Information Technology Act, 2000, and the rules made
                thereunder. This electronic contract does not require any
                physical, electronic, or digital signature. These Terms are
                published in compliance with Rule 3(1) of the Information
                Technology (Intermediaries Guidelines) Rules, 2011.
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            2. Terms of Use for Vajra (Powered by Nirantara)
          </Typography>
          <Box sx={{ marginLeft: "1rem" }}>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (a)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The Company will provide You with access of the Platform for the
                purpose of extending Services to the Customers, subject to Your
                continuous compliance with the terms and conditions stipulated
                herein. The Services are extended through the Platform that
                enables You: (i) to browse and view the Services offered by the
                Company, (ii) to arrange and schedule the appointment for
                availing any such Services, and (iii) to log in using
                credentials provided by Nirantara to access features that
                require authentication or submission of information.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (b)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You agree that the provision of Services rendered by You through
                the Platform shall be subject to certain specific and additional
                terms and conditions, which may be communicated by the Company
                from time to time. Your continued use of the Platform and the
                Services shall be deemed acceptance of such additional terms.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (c)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                In the process of developing the Platform, the Company has made
                every reasonable effort to ensure that the information presented
                is accurate and clearly expressed. Nevertheless, inadvertent
                errors, inaccuracies, or omissions may occur. The Company
                disclaims any responsibility or liability for any such errors or
                for the accuracy, completeness, or usefulness of the information
                available on the Platform. Users are encouraged to report any
                errors or issues to customer support. The Company reserves the
                right to correct, modify, remove, or add content on the Platform
                or in relation to the Services, at any time and at its sole
                discretion.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (d)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                We reserve the right at any time to modify, suspend or
                discontinue the Service and/ or eliminate any aspect or features
                of the Platform and/or the Services (or any part or content
                thereof) as it deems fit, without notice at any time and shall
                not be held liable to any third party for such change or
                modification, suspension or discontinuation. The Company makes
                no commitment, express or implied, to maintain or continue any
                aspect of the Platform / Services. The Company may attempt to
                notify You about material changes in the Terms of Service or the
                fees or the Services or features of Platforms, via any medium
                including notice on the Platform, You acknowledge and agree that
                it is Your responsibility to stay updated with any changes.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (e)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You agree to use the Platform only for lawful purposes and in
                accordance with these Terms. You shall not use the Platform to
                (i) engage in any fraudulent or misleading activities; (ii)
                upload or transmit viruses or other malicious code; (iii)
                infringe upon the rights of any third party, including
                intellectual property rights; (iv) interfere with or disrupt the
                functionality of the Platform or the servers/networks connected
                to it and (v) for any unauthorized or unsolicited advertising or
                promotional material.
              </Typography>
            </Box>
          </Box>

          <Typography
            gutterBottom
            sx={{ fontSize: "16px", fontFamily: "Inter", marginTop: "2rem" }}
          >
            <b>3. Description of Services</b> (hereinafter referred to as{" "}
            <b>“Services”</b>)
          </Typography>

          <Typography paragraph sx={{ fontFamily: "Inter", fontSize: "13px" }}>
            Nirantara offers an integrated Platform designed to accelerate
            sustainability efforts for businesses by providing:
          </Typography>

          <Box sx={{ marginLeft: "1rem" }}>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (a)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>Precise GHG Emissions Measurement:</b> Tracks Scope 1, 2, and
                3 emissions, including a driver mobile app for accurate
                transportation and logistics emissions data.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (b)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>Value Chain Emissions Tracking:</b>Captures emissions data
                from both upstream and downstream value chain partners.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (c)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>Benchmarking:</b> Allows clients to benchmark their ESG
                performance against industry standards and competitors.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (d)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>Water & Wastewater Metrics:</b> Monitors and tracks water and
                wastewater usage with detailed analysis.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (e)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>KPI Monitoring:</b> Tracks key performance indicators across
                environmental, social, and governance areas.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (f)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>Streamlined ESG Reporting: </b> Simplifies compliance with
                GRI and BRSR frameworks.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (g)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b> Dashboards & MIS Reports: </b> Provides real-time data
                visualizations through intuitive dashboards and detailed MIS
                reports.
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            4. Access and Use of the Website
          </Typography>

          <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1rem",
              }}
            >
              Users may access and browse the Platform as a guest or by logging
              in using credentials provided by Nirantara. Guest users may view
              general information and features but may have limited access to
              certain Services and functionalities. To access the full range of
              Services, Users will be required to use the login credentials
              shared by Nirantara. Users must keep these credentials
              confidential and are solely responsible for all activities carried
              out through their accounts. Each set of login credentials is
              intended for use by a single User only, and multiple logins or
              concurrent sessions using the same credentials across different
              devices, browsers, or individuals is strictly prohibited, unless
              expressly permitted in writing by Nirantara. Any unauthorized
              sharing or use of login credentials may result in immediate
              suspension or termination of the User’s access to the Platform, in
              addition to any other remedies available to Nirantara under
              applicable law. If any false, inaccurate, or misleading
              information is discovered in connection with a User’s access or
              usage, Nirantara reserves the right to suspend or terminate the
              User’s access to the Platform. Nirantara may also share relevant
              information with government authorities for identity verification
              or legal compliance, as required.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            5. User Responsibilities
          </Typography>
          <Box sx={{ marginLeft: "1rem" }}>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (a)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You hereunder represent, warrant and acknowledge that Nirantara
                shall use the information provided by You in accordance with its
                privacy policy specified on the Website and/or the Application.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (b)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You shall at all times, adhere to the applicable laws, rules and
                regulations while accessing the Platform and the Services.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (c)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You shall not attempt to gain any unauthorized access to or
                interfere with, damage or disrupt the Platform, or any part
                thereof, which may affect the security, integrity, availability,
                performance or smooth functionality of the Platform.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (d)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Upon confirmation of Your appointment for availing any Services
                on the Platform, You are deemed to acknowledge and agree to the
                service specific conditions/disclaimers vis-à-vis such Services
                availed by You as indicated on the Platform from time to time.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (e)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You agree that Nirantara shall utilize the information provided
                by You, including but not limited to Your name, contact details,
                residential address, and email address, in accordance with its
                privacy policy specified on the Website and/or the Application.
                You hereby expressly agree to such information being shared with
                the Company’s personnel/employees/representatives/affiliates (
                <b>“Nirantara Representatives”</b>) who may use the same to
                contact You for the purposes of rendering the requested
                Services.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (f)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You shall be diligent and cautious prior to handing over Your
                information to Nirantara Representatives for the purposes of
                rendering the Services. The Company shall not be liable for any
                misuse of such information and shall not be obligated to
                compensate You in such event. You shall ensure that either You
                or an authorized representative is present at the agreed time
                for the provision of Services.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (g)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You will treat the Nirantara Representatives assigned to You
                through the Platform with dignity and respect and You shall not
                cause harm to them or engage in any unlawful, threatening,
                harassing, abusive behavior or activity whilst availing the
                Services.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (h)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The Website and/or the Application are compatible only with
                certain devices/tablets/instruments/ hardware. The Company shall
                not be obligated to provide or update compatible hardware or
                devices necessary to access or use the Services and Website/
                Application and any updated thereto. The Company reserves the
                right to upgrade the list of compatible devices or system
                requirements as it may deem fit from time to time.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (i)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The Company shall have no responsibility for any loss or damage
                caused to device or any other hardware and / or software and/or
                instrument, including loss of data or effect on the processing
                speed, resulting from Your use of Our Website/
                Application/Services.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (j)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The Services are available in <b>Asia-Pacific:</b> Bangladesh,
                Sri Lanka, Nepal, Bhutan, Singapore, Malaysia, Indonesia,
                Taiwan, Philippines, Brunei, Hong Kong, Vietnam, New Zealand,
                Australia.
                <b> Middle East:</b> UAE, Oman, Saudi Arabia, Qatar, Kuwait,
                Bahrain, Jordan, Egypt, Israel, Georgia, Azerbaijan, Ukraine,
                Russia.
                <b> Europe & North America:</b> All European countries, UK, USA,
                and Canada. Further, You acknowledge, agree and confirm that the
                server of the Company on which the Platform is hosted in India.
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            6. Conduct of the User
          </Typography>
          <Box sx={{ marginLeft: "1rem" }}>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (a)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You understand and agree that You are solely responsible for
                compliance with any and all applicable laws, rules, regulations
                that may apply to Your use of the Website, Application, and
                Services. Without prejudice to the generality of the foregoing,
                the following may be noted:-
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{
                  pr: 1,
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "1.5rem",
                }}
              >
                (i)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You acknowledge and agree that the accessibility to the Website/
                Application is dependent on multiple external factors such as
                internet service providers, location, bandwidth and the Company
                does not guarantee accessibility to the Website/ Application at
                all times. In addition to the disclaimers and conditions set
                forth in the Terms of Service, the Company shall not be liable
                to the User for any damages arising from Your inability to
                access the Services provided via the Website/ Application at any
                time.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{
                  pr: 1,
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "1.5rem",
                }}
              >
                (ii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The Services availed through the Website or the Application are
                for Your personal and non-commercial use only and any other
                usage of the Application, Website or Services is prohibited.
                Your personal and non-commercial use of the Website, Application
                and / or Services shall be subjected to the following
                restrictions:
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{
                  pr: 1,
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "3rem",
                }}
              >
                (a)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You may not decompile, reverse engineer, or disassemble the
                contents of the Application and / or Website and/or Services or
                modify, copy, distribute, transmit, display, perform, reproduce,
                publish, license, create derivative works from, transfer, or
                sell any information or software obtained from the Application
                and / or Website and/or Services, or remove or tamper with any
                copyright, trademark registration, or other proprietary notices
                from the contents of the Application and / or Website and/or
                Services.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{
                  pr: 1,
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "3rem",
                }}
              >
                (b)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You will not (a) use this Application and / or Our Website
                and/or any of Our Service/s for commercial purposes of any kind,
                or (b) use the Application and / or Website/ and Services in any
                way that is unlawful, or harms the Company or any other person
                or entity as determined by the Company.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{
                  pr: 1,
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "3rem",
                }}
              >
                (c)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                No User shall be permitted to perform any of the following
                prohibited activities while availing Our Services:
              </Typography>
            </Box>
            <ul style={{ paddingLeft: "5rem" }}>
              <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
                Making, transmitting or storing electronic copies of materials
                protected by copyright without the permission of the owner,
                committing any act that amounts to the infringement of
                intellectual property or making available any material that
                infringes any intellectual property rights or other proprietary
                rights of anyone else;
              </li>
              <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
                Impersonate any person or entity, or falsely state the details
                or misrepresent Your affiliation with any person or entity;
              </li>
              <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
                Access or use the Application/Website in any manner that could
                damage, disable, overburden or impair any of the
                Application’s/Website’s servers or the networks connected to any
                of the servers on which the Application/Website is hosted;
              </li>
              <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
                Intentionally or unintentionally interfere with or disrupt the
                services or violate any applicable laws related to the access to
                or use of the Application/Website/Services, violate any
                requirements, procedures, policies or regulations of networks
                connected to the Application/Website/Services, or engage in any
                activity prohibited by these Terms;
              </li>
              <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
                Disrupt or interfere with the security of, or otherwise cause
                harm to, the Application/Website, materials, systems resources,
                servers or networks connected to or accessible through the
                Application/Website/Services or any affiliated or linked sites;
              </li>
              <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
                Interfere with, or inhibit any User from using and enjoying
                access to the Application/Website/ Services, or other affiliated
                sites, or engage in disruptive attacks such as denial of service
                attack on the Application/Website/Services or introduce viruses,
                malware, or harmful code;
              </li>
              <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
                Use deep-links, page-scrape, robot, spider or other automatic
                device, program, algorithm or methodology, or any similar or
                equivalent manual process, to increase traffic to the
                Application/Website/Services, to access, acquire, copy or
                monitor any portion of the Application /Website/Services, or in
                any way reproduce or circumvent the navigational structure or
                presentation of the Website/Application, or any content, to
                obtain or attempt to obtain any content, documents or
                information through any means not specifically made available
                through the Application/ Website/Services;
              </li>
              <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
                Alter or modify any details of the Services via wrongful means;
              </li>
              <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
                Any fraudulent use of the Platform or applicable Payment method
                to avail the Services, which causes any monetary loss to the
                Company as a result of Your action/inaction shall be recovered
                from You. Without prejudice to the above, the Company reserves
                the right to initiate legal proceedings against You for the
                fraudulent use of this Platform or for any other unlawful act or
                omission in breach of the Terms.
              </li>
              <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
                Use the Services for purposes that are not permitted by: (i)
                these Terms; and (ii) any applicable law, regulation or
                generally accepted practices or guidelines in the relevant
                jurisdiction; or
              </li>
              <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
                Violate any of the Terms specified under the Terms for the use
                of the Application /Website/Services.
              </li>
            </ul>
          </Box>
          <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
            <Typography
              component="span"
              sx={{
                pr: 1,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "3rem",
              }}
            >
              (d)
            </Typography>
            <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
              In the event of any breach of this Clause, the Company reserved
              the right to restrict Your access to the Services and/or pursue
              legal action including, but not limited to, claims for damages,
              civil remedies, or criminal prosecution, as applicable.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            7. Proprietary Information and Intellectual Property Right
          </Typography>
          <Box sx={{ marginLeft: "1rem" }}>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (a)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Except as expressly stated in the Terms, all rights, title, and
                interest in and to the Platform, including but not limited to
                all information, materials, content, software, trademarks,
                services marks, trade names, and trade secrets including but not
                limited to the software, text, images, graphics, video, script
                and audio, contained in the Platform and/or Services and data on
                the Platform, including but not limited to software, databases,
                text, graphics, icons, and hyperlinks, are the proprietary
                property (<b>“Proprietary Information”</b>) of Nirantara or its
                licensors and are protected by applicable intellectual property
                laws in India as well as other relevant jurisdictions. No
                Proprietary Information may be copied, downloaded, reproduced,
                modified, republished, uploaded, posted, transmitted or
                distributed in any way without obtaining prior written
                permission of Nirantara and nothing on the Platform and/or
                Services shall be deemed to confer a license of or any other
                right, interest or title to or in any of the intellectual
                property rights belonging to the Company, to the User. The
                Company shall at all times retain full and complete title to the
                information, content or materials and all intellectual property
                rights inserted by the Company on such medium. The Platform and
                Services are protected by the copyright, trademark, patent and
                other applicable laws of India. Nothing contained on the
                Platform or in the Services shall be construed as granting, by
                implication, estoppel or otherwise, any license or right to use
                any Proprietary Information without the express written
                permission of Nirantara.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (b)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Nirantara grants You a limited, non-exclusive, non-transferable,
                revocable license to access and use the Platform and Services
                solely for Your personal, non-commercial use and strictly in
                accordance with these Terms. Except the right specifically
                mentioned herein, no right, title or interest shall be
                transferred to the User.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (c)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You agree not to remove, alter or obscure any copyright,
                trademark, service mark or other proprietary rights in or
                associated with the Platform and/or Services. All trademarks,
                service marks, logos, trade names, and any other proprietary
                designations of Nirantara used on or in connection with the
                Platform and/and Services are trademarks of Nirantara in India
                and abroad or its licensors, and any goodwill derived from the
                use of the same shall inure solely to the benefit of Nirantara.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (d)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Certain content displayed or made available through the Platform
                may be owned by third parties. Such content has been reproduced
                by Nirantara with the appropriate consents or licenses from the
                respective third parties. All rights in such third-party
                content, including without limitation, trademarks, logos,
                copyrights, and service marks, shall remain with the respective
                third-party owners. You agree not to use, reproduce, distribute,
                or exploit any third-party content without obtaining the prior
                written consent of the respective right holders.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (e)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                All rights not expressly granted under these Terms are reserved
                by Nirantara. No provision of these Terms shall be interpreted
                to grant any license or right to the User under any patent,
                trademark, copyright, or other proprietary rights of Nirantara
                or its licensors, whether by implication, estoppel, or
                otherwise.
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            8. Data Privacy
          </Typography>

          <Box sx={{ alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1rem",
                mb: 1,
              }}
            >
              Your use of the Platform is also governed by Our Privacy Policy,
              which outlines how we collect, process, use, disclose, store and
              protect Your personal information. By accessing or using the
              Platform, You expressly consent to such processing, and You
              warrant that all data provided by You is accurate and in
              accordance with the Privacy Policy.
            </Typography>

            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1rem",
                mb: 1,
              }}
            >
              You further represent and warrant that all data provided by You is
              true, accurate, complete, and up to date. Any misrepresentation or
              failure to update such information may result in suspension or
              termination of Your access to the Platform or Services.
            </Typography>

            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1rem",
                mb: 1,
              }}
            >
              If You do not agree with the terms of the Privacy Policy, in whole
              or in part, please do not use the Platform.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            9. Breach and Violation of Terms
          </Typography>
          <Box sx={{ alignItems: "baseline", mb: 2, paddingLeft: "1rem" }}>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (a)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                In the event of any actual or threatened breach of these Terms
                by the User, the User acknowledges and agrees that the Company
                shall suffer irreparable harm for which monetary damages would
                be an inadequate remedy. Accordingly, in addition to any other
                legal or equitable remedies available, the Company shall be
                entitled to seek immediate injunctive or other equitable relief,
                including specific performance, or proving actual damages.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (b)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Any violation of these Terms or any other policy of the Company
                by the User may result in restriction of access to the Platform
                or Services (in whole or in part) apart from any legal remedy
                that the Company can avail as per the applicable law. The
                violation of these Terms could also result in institution of
                legal proceedings, including civil or criminal action, against
                You in accordance with applicable laws.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (c)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The Company reserves the right to report any activity that it
                suspects to be in violation of any applicable law or regulation
                to appropriate law enforcement authorities, regulatory bodies,
                or other third parties, and to cooperate with such authorities
                or bodies in any investigation or enforcement action.
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            10. Indemnity and Liability
          </Typography>
          <Box sx={{ alignItems: "baseline", mb: 2, paddingLeft: "1.3rem" }}>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (a)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The User agrees to unconditionally and irrevocably defend,
                indemnify and hold harmless the Company, its affiliates,
                subsidiaries and each of their respective officers, directors,
                employees and agents including Nirantara Representatives
                (collectively, the <b>“Indemnified Parties”</b>) , from and
                against any and all claims, damages, obligations, losses,
                liabilities, deficiencies, costs or debt, and expenses
                (including but not limited to attorney’s fees) arising from or
                in connection with: (i) use of and access of the
                Application/Website/Services by the User; (ii) any actual or
                alleged breach or violation by the User of any Term of these
                Terms and/or the privacy policy or any other policy of the
                conditions/disclaimers displayed on the Platform from time to
                time; (iii) violation, infringement or misappropriation by the
                User of any third party right, including without limitation, any
                copyright, property, or privacy right, including any applicable
                data protection or privacy law (such as the Digital Personal
                Data Protection Act, 2023), or any applicable law, rule,
                regulation, or order of any governmental or judicial authority;
                (iv) any claim that the User’s use of the
                Application/Website/Services has caused damage to a third party;
                (v) any unauthorized, illegal, or fraudulent use of the Platform
                or Services by You or any person acting on Your behalf; or (vi)
                any claims made by a third party arising out of or in connection
                with Your use of the Platform or Services.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (b)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                This indemnification obligation shall survive the expiration or
                termination of these Terms of Service and/or Your use of the
                Platform or Services.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (c)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                In addition to the Terms expressly provided, in no event shall
                the Company or any of its Indemnified Parties be liable to the
                User or any third party for any direct, indirect, special,
                exemplary, punitive, incidental, or consequential damages
                whatsoever, including but not limited to loss of profits, loss
                of data, business interruption, or other commercial damages or
                losses, whether arising under contract, tort, negligence, strict
                liability, or any other theory of liability, even if the Company
                has been advised of the possibility of such damages.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (d)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Without prejudice to the above, and to the maximum extent
                permitted by applicable law, the aggregate liability of the
                Company for any claims arising out of or in connection with
                these Terms or the use of the Platform or Services shall not
                exceed the total amount of consideration or fees actually
                received by the Company from You, if any, in the three month
                period immediately preceding the date of the claim.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (e)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The remedies available to the Company under these Terms are
                cumulative and not exclusive of any other legal or equitable
                remedies available to it under applicable laws.
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            11. Collection and Use of Personal Data
          </Typography>

          <Box sx={{ alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              By accessing or using the Platform and Services, You acknowledge
              and agree that the Company may collect, use, store, process and
              share certain personal data provided by You at the time of login
              or during the course of Your use of the Platform, including but
              not limited to, name, contact details, usage data, device
              information, and other information as may be required. Such data
              collection shall be in accordance with the Terms of Our Privacy
              Policy and applicable data protection laws including the Digital
              Personal Data Protection Act, 2023.
            </Typography>

            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              You acknowledge that the Company shall take reasonable security
              measures to protect Your personal data but does not guarantee
              absolute security. By using the Platform, You provide explicit
              consent to the collection and processing of Your data for purposes
              necessary to provide and improve the Services.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            12. Disclaimer
          </Typography>

          <Box sx={{ alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              You acknowledge, agree and confirm that the Company and/or its
              representatives will not be held responsible or in default for any
              delays or failure or issues in the performance resulting from acts
              beyond the control of the Company, including but not limited to
              acts of God, weather (floods, tempest, tsunami etc), power
              failure, governmental actions, war or national emergency (whether
              declared or not), acts of terrorism, protests, riot, lockdowns,
              civil commotion, fire, explosion, flood, and/or
              pandemics/epidemics
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            13. Indemnity and Liability
          </Typography>
          <Box sx={{ alignItems: "baseline", mb: 2, paddingLeft: "1.3rem" }}>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (a)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You acknowledge and agree that the Platform may include links to
                third-party websites or online resources, specifically under the
                “Resources” tab, which are provided solely for informational
                purposes. These links may include references to publicly
                available regulatory frameworks, guidelines, or other materials
                relevant to environmental, social, and governance (ESG)
                considerations.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (b)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Such third-party resources are not owned, operated, or
                controlled by Us, and We do not assume any responsibility for
                the content, accuracy, legality, or reliability of the
                information or materials made available on or through such
                third-party websites. We make no warranties or representations
                regarding any third-party links or content, and inclusion of
                such links shall not be construed as Our endorsement or
                recommendation.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (c)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You understand and agree that any access to or reliance on
                third-party websites or materials is at Your sole risk, and We
                shall not be liable for any loss or damage arising from such
                use. We encourage You to review the Terms and privacy policies
                of any third-party platforms You may visit through the links
                provided on the Platform.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (d)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                You understand that third-party website may independently
                collect and process Your personal data, and such collection
                shall be governed by their own privacy policies. We disclaim any
                liability in connection with such data collection.
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            14. Governing Law and Jurisdiction
          </Typography>
          <Box sx={{ alignItems: "baseline", mb: 2, paddingLeft: "1.3rem" }}>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (i)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                This Terms of Service shall be governed and construed in
                accordance with the laws of India without reference to any
                choice or conflict of law’s provisions. The courts of Chennai,
                Tamil Nadu shall have exclusive jurisdiction in case of any
                matter arising out of or in connection with this Terms.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (ii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The disputes arising out of or in connection with the Terms of
                Service and/or any other conditions/disclaimers forming part of
                the Platform shall be referred to arbitration to be conducted by
                sole arbitrator appointed by the Company and shall be settled in
                accordance with the Arbitration and Conciliation Act, 1996, as
                may be amended from time to time. The decision of the sole
                arbitrator shall be final and binding on the Parties. The venue
                and seat of arbitration shall be Mumbai and language shall be
                English.
              </Typography>
            </Box>
          </Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            15. Entire Agreement
          </Typography>

          <Box sx={{ alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              The Terms, along with the Privacy Policy, and any other guidelines
              made applicable to the Application/ Website/ Services from time to
              time, constitute the entire agreement between the Company and the
              User with respect to the access to or use of the Application,
              Website and the Services thereof.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            16. Assignment
          </Typography>

          <Box sx={{ alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              The User cannot assign or otherwise transfer their registration,
              rights or obligations under the Terms, or any r Service are freely
              transferable by the Company to any third parties without prior
              written consent of the User.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            17. Severability
          </Typography>

          <Box sx={{ alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              If, for any reason, a court of competent jurisdiction finds any
              provision of the Terms, or portion thereof, to be unenforceable,
              that provision shall be enforced to the maximum extent permissible
              so as to give effect to the intent of the parties as reflected by
              that provision, and the remainder of the Terms shall continue in
              full force and effect.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            18. Waiver
          </Typography>

          <Box sx={{ alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              Any failure by the Company to enforce or exercise any provision of
              the Terms, or any related right, shall not constitute a waiver by
              the Company of that provision or right.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            19. Feedback
          </Typography>

          <Box sx={{ alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              Any feedback provided by the User with respect to the Application
              shall be deemed to be non-confidential and may be used on an
              unrestricted basis to improve the quality of Services offered by
              the Company. Further, the User represents and warrants that (i)
              the feedback does not contain confidential or proprietary
              information of the User or of third parties; (ii) the Company is
              not under any obligation of confidentiality, express or implied,
              with respect to the feedback; and (iii) the User is not entitled
              to any compensation or reimbursement of any kind from the Company
              for the feedback under any circumstances.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            20. User Experience
          </Typography>

          <Box sx={{ alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              We attempt to make all best endeavors to provide Our Users with a
              content, satisfying and enjoyable experience. In the unlikely
              event that You face any issues or wish to give any feedback,
              please contact Us at{" "}
              <a href="mailto:support.vajra@nirantara.solutions">vajra.support@nirantara.solutions.</a>
            </Typography>

            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              You acknowledge and agree to the Terms and understand that they
              shall apply to Your use of the Website/Application and Services.
              The Company has given You a reasonable opportunity to review these
              Terms and after reviewing and understanding the Terms, You have
              agreed to the same.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              marginTop: "2rem",
            }}
            gutterBottom
          >
            21. Grievance Redressal
          </Typography>

          <Box sx={{ alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              If You have any complaints regarding violations of the Information
              Technology Act, 2000 as well as the Digital Personal Data
              Protection Act, 2023, its applicable rules, or any other concerns
              related to the Website, You may contact the Grievance Officer at
              the Company at the details provided below:
            </Typography>

            <ul
              style={{
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "3rem",
                marginBottom: "1rem", // 'mb' should be 'marginBottom' in plain style object
              }}
            >
              <li style={{ fontSize: "13px", fontFamily: "Inter", marginBottom: "0.2rem", }}>
                <span style={{ fontWeight: "bold" }}>Name:</span> Vaibhav Singh
                and Sachin Unni
              </li>
              <li style={{ fontSize: "13px", fontFamily: "Inter", marginBottom: "0.2rem", }}>
                <span style={{ fontWeight: "bold" }}>Email:</span>{" "}
                <a href="mailto:support.vajra@nirantara.solutions">Support.Vajra@nirantara.solutions</a>
              </li>
              <li style={{ fontSize: "13px", fontFamily: "Inter", marginBottom: "0.2rem", }}>
                <span style={{ fontWeight: "bold" }}>Working Days:</span> Monday
                - Friday
              </li>
              <li style={{ fontSize: "13px", fontFamily: "Inter", marginBottom: "0.2rem", }}>
                <span style={{ fontWeight: "bold" }}>Working Hours:</span> 9AM –
                6PM
              </li>
            </ul>

            <Typography
              sx={{
                pr: 2,
                fontFamily: "Inter",
                fontSize: "13px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              We are committed to addressing Your concerns in a timely manner.
            </Typography>
          </Box>

          <Box sx={{ alignItems: "baseline", mb: 2 }}>
            <Typography
              sx={{
                pr: 2,
                fontFamily: "Times New Roman",
                fontSize: "18px",
                paddingLeft: "1.3rem",
                mb: 1,
              }}
            >
              If You have any complaints regarding violations of the Information
              Technology Act, 2000 as well as the Digital Personal Data
              Protection Act, 2023, its applicable rules, or any other concerns
              related to the Website, You may contact the Grievance Officer at
              the Company at the details provided below:
            </Typography>
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default TermsOfServices;
